import React from 'react';
import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import type { FormDropdown } from 'types/cms';

import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

const Dropdown = ({
  control,
  identifier,
  label,
  dropdown_items,
  required,
}: FormDropdown & { control: Control }) => {
  const labelId = `select-${identifier}`;
  const requiredLabel = required ? `${label} *` : label;
  return (
    <FormControl fullWidth>
      <InputLabel id={labelId}>{requiredLabel}</InputLabel>
      <Controller
        name={identifier}
        control={control}
        defaultValue=""
        render={props => (
          <Select
            labelId={labelId}
            label={requiredLabel}
            {...props}
            required={required}
            data-testid={identifier}
          >
            {dropdown_items.map(({ id, value, display_value }) => {
              const key = `option-${id}`;
              return (
                <MenuItem key={key} value={value}>
                  {display_value ? display_value : value}
                </MenuItem>
              );
            })}
          </Select>
        )}
      />
    </FormControl>
  );
};

export default Dropdown;
